import { DocumentTypeEnum } from '../enums/document-type.enum';

export const listOfDocumentsCanChangeType = [
  DocumentTypeEnum.RETURN_TO_WORK,
  DocumentTypeEnum.MEDICAL_DISCONTINUANCE,
];
